module.exports = __webpack_public_path__ + "img/logo3.7c15ca28.png";